export const getConsortium = (stripes) => stripes.user?.user?.consortium;
